import api from "@/assets/scripts/api";
import { genMaterialData } from "@/assets/scripts/common";
import { genInitSizeInfo } from "@/pages/banner/js/banner-static";
import http from "@/plugins/http";
// 按照行数获取文字样式
export const getTextStyles = async (bannerTextLine, pageIndex, pageSize) => {
  let result = await http.get(api.textStyles, {
    textLineCount: bannerTextLine,
    pageSize: pageSize || 10000,
    pageIndex: pageIndex || 0,
    platformType: 1,
  });
  return result.data.list;
};
export const saveBannerToBase = async (bannerDatas, id = "", userId = "") => {
  let bannerDataList = JSON.parse(JSON.stringify(bannerDatas));
  bannerDataList.find((item, index) => {
    if (item.type === 0) {
      bannerDataList.splice(index, 1);
      bannerDataList.unshift(item);
      return true;
    }
  });
  let { tagId, elementId, textStyleId, backgroundId, isAiElement } = bannerDataList[0];
  console.log("bannerDataList", bannerDataList[0]);
  let scheme = {
    id,
    tagId,
    elementId,
    isAiElement,
    backgroundId,
    textStyleId,
    platformType: 1,
    sizeTexts: bannerDataList.map(bannerData => ({
      sizeId: bannerData.sizeId,
      logoContent: bannerData.logoContent,
      texts: bannerData.textValue,
      labelStyle: bannerData.textStyle.map(item => {
        return item.showLabelStyle ? item.labelStyle : "";
      }),
    })),
  };
  if (userId) {
    return http.post(api.saveSchemeByUser, {
      ...scheme,
      userId,
    }).catch((err) => {
      console.log("报错banner失败", err);
    });
  }
  return http.post(api.scheme, scheme).catch(() => { });
};
export const getSizes = async params => {
  let { data } = await http.get(api.picSizes, params);
  return data.list || [];
};

export const structSizes = (sizes, dataList) => {
  sizes.map(item => {
    item.isSelect = false;
    item.sizes.map(size => {
      size.isTextExceed = false;
      size.isSelect = false;
      size.textStyle.forEach(textStyle => {
        const limits = textStyle.textCountLimit.split("<x<");
        textStyle.min = limits[0];
        textStyle.max = limits[1];
      });
      const elementInfo = {
        elementWidth: size.elementWidth,
        elementHeight: size.elementHeight,
        offsetX: size.offsetX,
        offsetY: size.offsetY,
        remainPart: size.remainPart,
      };
      const textInfo = {
        textPositionX: size.textPositionX,
        textPositionY: size.textPositionY,
        textAlignType: size.textAlignType,
        lineCount: size.lineNum,
      };
      size.size = {
        width: size.width,
        height: size.height,
      };
      size.elementInfo = elementInfo;
      size.textInfo = textInfo;
      if (dataList) {
        for (let banner of dataList) {
          if (banner.sizeId === size.id) {
            size.isTextExceed = banner.isTextExceed;
            size.isSelect = true;
          }
        }
      }
    });
  });
  return sizes;
};
export const formatTextStyle = textStyles => {
  textStyles.forEach((textStyle, index) => {
    let arr = textStyle.textCountLimit.split("<x<");
    if (index) {
      textStyle.marginTop = textStyle.marginTop || "8";
    }
    textStyle.max = arr[1];
    textStyle.min = arr[0];
    textStyle.labelStyle = "样式1";
    textStyle.showLabelStyle = false;
  });
};
export const genBannerDataBySize = (sizeInfo, element, background) => {
  const {
    id,
    elementHeight,
    elementWidth,
    height,
    width,
    lineNum,
    offsetX,
    offsetY,
    remainPart,
    sizeName,
    textAlignType,
    textPositionX,
    textPositionY,
    textStyle,
    textStyleId,
    type,
  } = sizeInfo;
  const textValue = textStyle.map(item => item.text || "").filter(item => item);
  formatTextStyle(textStyle);
  const banner = {
    textStyleId,
    sizeId: id,
    type,
    sizeName,
    elementTypeId: 2, // 元素类型(2:素材banner, 3:头像banner)
    size: {
      width,
      height,
    },
    elementInfo: {
      elementWidth,
      elementHeight,
      offsetX,
      offsetY,
      remainPart,
    },
    textInfo: {
      textPositionX,
      textPositionY,
      textAlignType,
      lineCount: lineNum,
    },
    textStyle,
  };
  if (textValue.length) {
    banner.textValue = textValue;
  }
  if (element && background) {
    const eTagIds = element.tagIds;
    const bTagIds = background.tagIds;
    // 取eTagIds和bTagIds的交集
    const tagIds = eTagIds.filter(item => bTagIds.includes(item));
    banner.tagId = tagIds[0] || bTagIds[0];
    return {
      ...genMaterialData(element, background),
      ...banner,
    };
  }
  return banner;
};
export const isLabelStyleVisible = (textStyles, index) => {
  // 如果是三行则只在第三行可添加标签样式，如果是两行则可在副标题添加样式
  let lineNum = textStyles.length;
  const item = textStyles[index];
  if (["阿里巴巴普惠体 Regular", "阿里巴巴普惠体 Light"].includes(item.fontFamily) && lineNum === 2) {
    return true;
  }
  return lineNum === 3 && index === 2;
};
export const getBannerList = async (params) => {
  let url = api.schemes;
  if (params.userId) {
    url = api.userBanners;
  }
  let {
    data: { list, totalPage },
  } = await http.get(url, params);
  if (!list) return {
    list: [],
    totalPage: 0,
  };
  // 构造需要展示的数据
  list.forEach((banner) => {
    const { textValue, labelStyle, elementTypeId } = banner;
    const lineNum = textValue.length >= 2 ? textValue.length : 2;
    const { textInfo, textStyle } = genInitSizeInfo(
      elementTypeId,
      lineNum
    );
    banner.textStyle = textStyle;
    banner.textInfo = textInfo;
    banner.textStyle.forEach((item, index) => {
      const labelName = labelStyle[index];
      item.labelStyle = labelName || '样式1';
      item.showLabelStyle = !!item.labelStyle.length;
    });
  });
  return {
    list,
    totalPage,
  };
};

export const getDesignDetail = async (schemeId) => {
  let { data } = await http.get(
    `${api.scheme}?schemeId=${schemeId}&platformType=1`
  );
  return data;
};
